import "../sass/child-styles.scss"

import ChildThemeAnimations from "./modules/ChildThemeAnimations";
import LogoCenteredHeader from "./modules/LogoCenteredHeader";
import CarouselTestimonials from "./modules/CarouselTestimonials";

const childThemeAnimations = new ChildThemeAnimations();
const logoCenteredHeader = new LogoCenteredHeader();
const carouselTestimonials = new CarouselTestimonials();
